import React from "react";
import {
  CurrencyInput,
  DateInput,
  PercentageInput,
  PercentageIntegerInput,
  Select,
  TextInput,
} from "../../../components/forms";
import { debtBenefitChoices } from "../../../constants";
import { JumpToPageIcon } from "./utils";
import { Form } from "react-bootstrap";
import { extractedValuesAppend } from "./ExtractedValuesAppend";
import HTMLReadOnlyText from "../../../components/forms/HTMLReadOnlyText";

export const ExtractedValuesForm = ({ values, jumpToPage, handleSubmit }) => (
  <>
    <Form.Row>
      <DateInput name="policy_date" label="Policy Date" />
      <Select label="DB Option" name="debt_benefit" placeholder="Select DB option" options={debtBenefitChoices} />
      <CurrencyInput name="face_amount" label="Face Amount" />
    </Form.Row>
    <Form.Row>
      <PercentageInput
        name="current_rate"
        label="Current Rate"
        append={extractedValuesAppend(jumpToPage, values.current_rate_confidence, values.current_rate_page)}
      />
      <HTMLReadOnlyText value={values.current_rate_reasoning} md={8} />
    </Form.Row>
    <Form.Row>
      <CurrencyInput
        name="current_value"
        label="Current Value"
        append={extractedValuesAppend(jumpToPage, values.current_value_confidence, values.current_value_page)}
      />
      <HTMLReadOnlyText value={values.current_value_reasoning} md={8} />
    </Form.Row>
    <Form.Row>
      <PercentageInput
        name="guaranteed_rate"
        label="Guaranteed Rate"
        append={extractedValuesAppend(jumpToPage, values.guaranteed_rate_confidence, values.guaranteed_rate_page)}
      />
      <HTMLReadOnlyText value={values.guaranteed_rate_reasoning} md={8} />
    </Form.Row>
    <Form.Row>
      <DateInput
        name="illustration_date"
        label="Illustration Date"
        append={extractedValuesAppend(jumpToPage, values.illustration_date_confidence, values.illustration_date_page)}
      />
      <HTMLReadOnlyText value={values.illustration_date_reasoning} md={8} />
    </Form.Row>
    <Form.Row>
      <TextInput
        name="premium_frequency"
        label="Premium Frequency"
        append={extractedValuesAppend(jumpToPage, values.premium_frequency_confidence, values.premium_frequency_page)}
      />
      <HTMLReadOnlyText value={values.premium_frequency_reasoning} md={8} />
    </Form.Row>
  </>
);
